import isGHMC, {
  getCurrentDateTime,
  getStartOfCurrentDate
} from "./../../../../Common/helper/helpar";
import { Formik, Form, Field } from "formik";
import { useEffect, useState } from "react";
import { TippingFeeExport } from "./TippingFeeExport";
import TippingFeeCalculationStore from "./store/TippingFeeCalculationStore";

export const TippingFeeCalculationFilters = () => {
  const { fetchTippingFeeCalculationReport } = TippingFeeCalculationStore();
  const isProd = isGHMC();
  const currentDate = getCurrentDateTime();
  const currentDateTime = getStartOfCurrentDate();

  const getLast30DaysDate = (day) => {
    const toDate = new Date(day);
    const thirtyDaysAgo = new Date(toDate.setDate(toDate.getDate() - 30));
    return thirtyDaysAgo.toISOString().split("T")[0];
  };

  const defaultValues = {
    FromDate: currentDateTime,
    ToDate: currentDate
  };

  const [initialFilterValues, setInitialFilterValues] = useState(defaultValues);

  useEffect(() => {
    const storedFilters = localStorage.getItem("tippingFeeFilters");
    if (storedFilters) {
      const parsedFilters = JSON.parse(storedFilters);
      setInitialFilterValues(parsedFilters);
      fetchTippingFeeCalculationReport(parsedFilters);
    } else {
      fetchTippingFeeCalculationReport(defaultValues);
    }
  }, []);

  const handleSubmit = (values) => {
    localStorage.setItem("tippingFeeFilters", JSON.stringify(values));
    fetchTippingFeeCalculationReport(values);
  };

  const handleReset = (resetForm) => {
    resetForm({ values: defaultValues });
    localStorage.removeItem("tippingFeeFilters");
    fetchTippingFeeCalculationReport(defaultValues);
  };

  return (
    <>
      <Formik initialValues={initialFilterValues} enableReinitialize onSubmit={handleSubmit}>
        {({ values, setFieldValue, resetForm }) => (
          <Form>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <div className="d-flex align-items-end gap-2 mb-2">
                <div style={{ width: "200px" }}>
                  <div className="form-group-filter">
                    <label className="form-label w-100 text-left">From Date</label>
                    <Field
                      type="datetime-local"
                      id="FromDate"
                      name="FromDate"
                      className="form-control bg-white"
                      min={values.ToDate && getLast30DaysDate(values.ToDate)}
                      max={values.ToDate || currentDate}
                      required
                    />
                  </div>
                </div>
                <div style={{ width: "200px" }}>
                  <div className="form-group-filter">
                    <label className="form-label w-100 text-left">To Date</label>
                    <Field
                      type="datetime-local"
                      id="ToDate"
                      name="ToDate"
                      className="form-control bg-white"
                    />
                  </div>
                </div>

                <button
                  type="submit"
                  className={`btn w-90 ${isProd ? "search-ghmc" : "search-swm"}`}
                >
                  Search
                </button>
                <button
                  type="reset"
                  className={`btn w-90 ${isProd ? "search-ghmc" : "search-swm"}`}
                  onClick={() => handleReset(resetForm)}
                >
                  Reset
                </button>
              </div>
              <div className="mt-4 d-flex">
                <TippingFeeExport />
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};
